const MissedShotEvent = ({ event, getPlayerName, getTeamAbbreviation }) => {
    const shootingPlayerId = event.details?.shootingPlayerId;
    const shootingPlayerName = getPlayerName(shootingPlayerId);
    const shootingPlayerTeamId = event.details?.eventOwnerTeamId;
    const shootingPlayerTeamAbbrev = getTeamAbbreviation(shootingPlayerTeamId);
    const shootingPlayerMugshotUrl = shootingPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${shootingPlayerTeamAbbrev}/${shootingPlayerId}.png` : null;
    const goalieId = event.details?.goalieInNetId;
    const goalieName = getPlayerName(goalieId);
    const goalieMugshotUrl = goalieId ? `https://assets.nhle.com/mugs/nhl/20242025/${getTeamAbbreviation(event.details?.eventOwnerTeamId)}/${goalieId}.png` : null;
    const reason = event.details?.reason || 'N/A';
    const shotType = event.details?.shotType || 'N/A';

    return (
        <div className="missed-shot-event">
            <div className="flex items-center mb-2">
                <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
                <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
                <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
                <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
                <span className="text-sm font-semibold text-gray-700 mr-2">{shootingPlayerName}</span>
                {shootingPlayerMugshotUrl && (
                    <img
                        src={shootingPlayerMugshotUrl}
                        alt={shootingPlayerName}
                        className="inline-block ml-2 w-8 h-8 rounded-full"
                    />
                )}
                <span className="text-sm font-semibold text-gray-700 mx-2">Missed Shot</span>
                <span className="text-sm text-gray-900 mr-2">{reason}</span>
                <span className="text-sm font-semibold text-gray-700 mx-2">Shot Type:</span>
                <span className="text-sm text-gray-900 mr-2">{shotType}</span>
                <span className="text-sm font-semibold text-gray-700 mx-2">Goalie:</span>
                {goalieMugshotUrl && (
                    <img
                        src={goalieMugshotUrl}
                        alt={goalieName}
                        className="inline-block ml-2 w-8 h-8 rounded-full"
                    />
                )}
                <span className="text-sm text-gray-900">{goalieName}</span>
            </div>
        </div>
    );
};

export default MissedShotEvent;
